var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38",
    "data-name": "Group 38",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.436,
    height: 21.032,
    viewBox: "0 0 22.436 21.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M19.9,9.35H2.538A2.54,2.54,0,0,0,0,11.889V27.846a2.539,2.539,0,0,0,2.538,2.536H19.9a2.538,2.538,0,0,0,2.536-2.536V11.889A2.539,2.539,0,0,0,19.9,9.35Zm-5.391,3.776a2.451,2.451,0,1,1-2.451,2.451A2.451,2.451,0,0,1,14.508,13.126Zm4.6,14.91H3.683a.693.693,0,0,1-.673-1.094l4.206-8.331a.708.708,0,0,1,1.3-.121l4.23,5.527a1.037,1.037,0,0,0,1.606.1l1.035-1.048a.985.985,0,0,1,1.564.132l2.679,3.827C20.014,27.586,19.781,28.036,19.1,28.036Z",
    transform: "translate(0 -9.35)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.c633cc7806f119f152d909fb036ba6c2.svg";
export { ForwardRef as ReactComponent };